; (() => {
	'use strict';

	window.PARAMS = (() => {
		'use strict';

		const AUTH = {
			SID: Auth.get("SID") ?? "",

			title: Auth.get("title") ?? "",
			email: Auth.get("email") ?? "",
			postal_address: Auth.get("postal_address") ?? "",
			postal_index: Auth.get("postal_index") ?? "",
			phone: Auth.get("phone") ?? "",
			inns: Auth.get("inns") ?? "",
			inn: Auth.get("inns")?.[0] ?? "",

			isIp: Auth.get('isIp') ?? false,
			isFiz: Auth.get('isFiz') ?? false,
			isOper: Auth.get('isOper') ?? false,
			isAdmin: Auth.get('isAdmin') ?? false,
			isInner: Auth.get('isInner') ?? false, //true,
			isPerson: Auth.get('isPerson') ?? false,
			isSmsRegistration: Auth.get('isSmsRegistration') ?? false,

			isBankrSeller: Auth.get('isBankrSeller') ?? false, // Пользователь имеет роль Организатора по банкротству
			canPublishAdditionalDebtors: Auth.get('canPublishAdditionalDebtors') ?? false, //  Организатор может создавать много должников в торгах
			comAllTypes: Auth.get('comAllTypes') ?? false, // Организатор может создавать коммерческие торги любого типа
			comTorgSpecTarif: Auth.get('comTorgSpecTarif') ?? false, // на спецтарифе? (для коммерческих)
			canChangeComOwner: Auth.get('canChangeComOwner') ?? false,  //  Организатор может менять собственника в коммерческих торгах
			x_com_other_zadat: Auth.get('x_com_other_zadat') ?? false, // задаток на свой счет
			x_com_svoy_poryadok: Auth.get('comTorgSvoyPoryadok') ?? false, // спецтариф
			comManyLots: Auth.get('comManyLots') ?? false,  // Организатор может создавать много лотов в ком торгах

			balance: Auth.get('getAllowedSaldoUsl') ?? 0, //  Баланс счета

			// Подпись
			isUseGosKey: Auth.get('isUseGosKey') ?? false,
		};

		const CONF = {
			isStage: Conf.get('isStage') ?? false,

			//$conf.getInt('max_text_length', 2000)

			// Форма подачи предложений о цене
			showType3: Conf.get('showType3') ?? "",
			showType4: Conf.get('showType4') ?? "",
			showType6: Conf.get('showType6') ?? "",
			showType8: Conf.get('showType8') ?? "",
			showType9: Conf.get('showType9') ?? "",

			fixed_dog_zadat: Conf.get('fixed_dog_zadat') ?? "",
			lot_title_max_size: Number(Conf.get('lot_title_max_size')) ?? 3000,

			kinescope_video_enabled: Conf.get("kinescope_video_enabled") ?? false,
			kinescope_max_video_size: Number(Conf.get("kinescope_max_video_size")) ?? 500,
			cian_org_edit_allow: Boolean(Conf.get("cian_org_edit_allow")) ?? false,

			// карта
			map_max_polygons_bankr: Number(Conf.get('map_max_polygons_bankr')) ?? 1,
			map_max_polygons_comm: Number(Conf.get('map_max_polygons_comm')) ?? 10,

			// Подпись
			goskey_allowed_ext: Conf.get("goskey_allowed_ext").split(",") ?? [],
			filtered_goskey_allowed_ext: Conf.get("goskey_allowed_ext").replace(/(,|\.)(\S)/g, '$1 $2'),
			goskey_allowed_ext_for_change: Conf.get("goskey_allowed_ext_for_change").split(",") ?? [],
			goskey_package_max_size: Conf.get("goskey_package_max_size") ?? 0,
			goskey_expire_minutes: parseInt(Conf.get("goskey_expire_minutes")) || 5,

			// загрузка
			valid_file_extensions: Conf.get("valid_file_extensions") ?? ['png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx', 'zip', 'txt', 'xls', 'xlsx', 'heic', 'sig', 'p7z', 'sgn'],

			// dadata
			dadata_token: Conf.get("dadata_token") ?? "",
			email_confirm_code: Conf.get("email_confirm_code") ?? 6,
		};

		const ALL_PARAMS = { ...AUTH, ...CONF };


		return {
			auth: Object.freeze({ ...AUTH }),
			conf: Object.freeze({ ...CONF }),

			// Доступ по ключу параметра
			...Object.freeze(ALL_PARAMS),

			// Получить несколько полей сразу
			pick: (...keys) => {
				const result = {};
				for (const key of keys) {
					if (ALL_PARAMS.hasOwnProperty(key)) {
						result[key] = ALL_PARAMS[key];
					}
				}
				return result;
			},

			// Проверка наличия параметра
			is: (flag) => ALL_PARAMS[flag] === true,
		}
	})();

	document.addEventListener('alpine:init', () => {
		Alpine.store("auth", {
			...PARAMS.auth,

			isInner: this.isOper || this.isAdmin || PARAMS.auth.isInner || false,

		});
	});
})();
